import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GalleryDto, Section } from '@nusign/picflow-backend-types';
import { firstValueFrom } from 'rxjs';
import { sortSubGalleries } from '../../../lib/sort-subgalleries';
import { GalleryUrlService } from '../../../services/gallery-url.service';
import { GalleryService } from '../../../services/gallery.service';
import { GalleryItemComponent } from '../../../shared-extra/components/gallery-item/gallery-item.component';

@Component({
  selector: 'app-album-section',
  templateUrl: './album-section.component.html',
  styleUrls: ['./album-section.component.scss'],
  standalone: true,
  imports: [RouterLink, GalleryItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlbumSectionComponent implements OnInit {
  private galleryService = inject(GalleryService);
  private swapGalleryInUrlService = inject(GalleryUrlService);
  @Input() section: Section;
  @Input() parentGallery: GalleryDto;
  @Input() embedMode: boolean;
  galleries: GalleryDto[] = [];
  links: { [galleryId: string]: string[] } = {};
  private check = inject(ChangeDetectorRef);

  async ngOnInit() {
    if (!this.section?.id) return;
    if (!this.parentGallery?.id) return;
    try {
      const galleries = await firstValueFrom(
        this.galleryService.getSectionGalleries(this.section.id, this.parentGallery.id)
      );
      this.galleries = sortSubGalleries(galleries, this.section.sorting);
      this.createLinks();
    } catch (err) {
      if (!(err instanceof HttpErrorResponse)) throw err;
      if (err.status !== 401 && err.status !== 403) throw err;
      console.warn('Couldnt fetch Subgalleries due to permissions error');
    }
    this.check.detectChanges();
  }

  private createLinks() {
    this.links = {};
    this.galleries.forEach(gallery => {
      this.links[gallery.id] = this.swapGalleryInUrlService.getChildPath(this.parentGallery, gallery);
    });
  }
}
